module.exports = __webpack_public_path__ + "img/yuanquan.ab3fdbc7.png";